csmodule.controller('AssetsWidgetCtrl', [
  '$timeout',
  '$scope',
  '$modalInstance',
  '$http',
  'prefix',
  'dataSet', function($timeout,$scope, $modalInstance, $http, prefix, dataSet){
  $scope.datas = _.isObject(dataSet['datas']) ? dataSet['datas'] : {};
  $scope.loading=true;
  $scope.page = 1;
  $scope.viewType = 'default';
  $scope.treeRows = [];
  $scope.iconLoading = 'fa fa-spinner fa-spin';
  $scope.iconExpand = 'fa fa-plus';
  $scope.iconCollapse = 'fa fa-minus';
  $scope.iconLeaf = 'fa fa-circle';
  $scope.expandingProperty = {};
  $scope.colDefinitions = [];
  $scope.selectedAssets = _.has($scope.datas,'selectedAssets') && _.isArray($scope.datas['selectedAssets']) ? $scope.datas['selectedAssets'] : [];
  $scope.showInfinitescroll = true;
  $scope.searchDisable = false;
  $scope.inputs={};
  $scope.inputs.searchText = '';
  $scope.totalRows=0;
  $scope.reachedEndOfPage = false;
  $scope.fixedHeader=true;
  $scope.ajaxAction = null;
  $scope.viewScreen = dataSet.viewScreen;

  // Replace function declaration from directive inputs
  if(isFunction(dataSet['resolveUrl'])) _resolveUrl = dataSet['resolveUrl'];

  var columns = [
    {field: 'groupDescription', displayName: 'Group', expanding_property: true, className: 'col-w-20'},
    {field: 'typeDescription', displayName: 'Type', className: 'col-w-30' },
    {field: 'listData', displayName: 'Identifiable field', className: 'col' }
  ];
  $scope.propertyId = dataSet.params.propertyId;
  $scope.tablePKID= dataSet.params.tablePKID;
  $scope.screenType = dataSet.params.screenType;

  $scope.reset = function() {
    $scope.treeRows = [];
    $scope.selectedAssets = [];
    $scope.viewType = 'default';
    $scope.page=1;
    $scope.showInfinitescroll = true;
    $scope.reachedEndOfPage = false;
    $scope.totalRows=0;
  };

  $scope.showPagination = function() {
    if($scope.showInfinitescroll && $scope.totalRows > getRootRowsCount()) {
      return true;
    }
    if($scope.totalRows === getRootRowsCount()) {
      $scope.reachedEndOfPage = true;
    }
  };

  $scope.showLoader = function() {
    if($scope.loading && $scope.page===1) {
      return true;
    }
  };

  $scope.assetInfiniteScroll = function() {
    if(! $scope.reachedEndOfPage ) {
      $scope.page++;
      $scope.manageAssets('', 'pagination');
    }
  };

  //# Load asset records with pagination options.
  $scope.manageAssets = function(searchText, requestType) {
      $scope.loading = true;
      var type = _.isUndefined(requestType) ? false : requestType;
      var params = _.isUndefined(searchText) || searchText==='' ? {page: $scope.page} : { searchText: encodeURIComponent(searchText) };
      if($scope.viewType === 'searchText') {
        $scope.searchDisable = true;
      }
      $scope.treeRows= [];
      $http.get( _resolveUrl(params) ).success(function (data,status){
        if(status == 200){
          if($scope.viewType==='default') {
            var _datas = _prepareRecords(data);
            if(type==='pagination'){
              $scope.treeRows = $scope.treeRows.concat(_datas.records);
            }
            else {
              $scope.treeRows = _datas.records;
            }
            $scope.expandingProperty = _datas.expanding_property;
            $scope.colDefinitions = _datas.cols;
            $scope.totalRows = parseInt(data.assetTotalCount); console.log(getRootRowsCount(), $scope.totalRows);
            if($scope.totalRows === getRootRowsCount()) {
              $scope.reachedEndOfPage = true
            }
          }
          else if($scope.viewType === 'searchText') {
            //var data = angular.fromJson({"assetResults":{"23":{"listData":"ABCD-3 N","assetId":23,"subAssetCount":"0","groupDescription":"Burner","typeDescription":"Nozzle","parentAssetId":20},"20":{"listData":"May be \/ One working","assetId":20,"subAssetCount":"1","groupDescription":"Burner","typeDescription":"Burner","parentAssetId":null},"22":{"listData":"Yes","assetId":22,"subAssetCount":"0","groupDescription":"Water heaters","typeDescription":"Bajaj","parentAssetId":null},"21":{"listData":"Water heaters \/ Bajaj","assetId":21,"subAssetCount":"0","groupDescription":"Water heaters","typeDescription":"Bajaj","parentAssetId":null},"19":{"listData":"Description type of burner \/ Now working","assetId":19,"subAssetCount":"0","groupDescription":"Burner","typeDescription":"Burner","parentAssetId":null},"18":{"listData":"ABCD-2Sub","assetId":18,"subAssetCount":"0","groupDescription":"Burner","typeDescription":"Nozzle","parentAssetId":8},"8":{"listData":"ABCD-2","assetId":8,"subAssetCount":"1","groupDescription":"Burner","typeDescription":"Nozzle","parentAssetId":3},"3":{"listData":"Burner type with its description can be handle on here \/ One working \/ Yes","assetId":3,"subAssetCount":"2","groupDescription":"Burner","typeDescription":"Burner","parentAssetId":1},"1":{"listData":"Grouping level of form structure \/ Its a type level of form structure \/ Yes","assetId":1,"subAssetCount":"3","groupDescription":"V4-Assets","typeDescription":"V4-Assets","parentAssetId":null},"17":{"listData":"Nozzle-23 \/ Yes \/ Yes","assetId":17,"subAssetCount":"0","groupDescription":"Burner","typeDescription":"Nozzle","parentAssetId":null},"16":{"listData":"Big burner chaning \/ No \/ No","assetId":16,"subAssetCount":"0","groupDescription":"Burner","typeDescription":"Nozzle","parentAssetId":null},"15":{"listData":"Dynamic \/ Model Dependency","assetId":15,"subAssetCount":"0","groupDescription":"Dynamic","typeDescription":"Model Dependency","parentAssetId":1},"9":{"listData":"ABCD-1","assetId":9,"subAssetCount":"0","groupDescription":"Burner","typeDescription":"Nozzle","parentAssetId":3},"7":{"listData":"Its need to update them \/ Now working \/ No","assetId":7,"subAssetCount":"0","groupDescription":"Burner","typeDescription":"Burner","parentAssetId":1}}});
            var _datas = _transformAsTree(data, true);
            //console.log('auto', autoExpand(_datas));
            $scope.treeRows = _datas;
            //console.log('$scope.treeRows', $scope.treeRows);
            $scope.searchDisable = false;
          }
          $scope.loading = false;
        }
      });
  };
  $scope.manageAssets();
  _enableTooltip();

  $scope.onChangeSearch = function() {
    if($scope.inputs.searchText === '') {
      $scope.searchAssets('');
      //$scope.searchDisable = true;
    }
    else {
      $scope.searchDisable = false;
    }
  };

  $scope.searchAssets = function(searchText) {
    $scope.searchDisable = true;
    if(searchText == '') {
      $scope.reset();
      $scope.manageAssets();
      $scope.searchDisable = true;
    } else {
      //$scope.manageSearchAsset($scope.inputs.searchText);
      $scope.treeRows=[];
      $scope.viewType = 'searchText';
      $scope.showInfinitescroll = false;
      $scope.manageAssets(searchText);
    }
  };

  $scope.removeFromSelectedItem = function(item, index) {
    var assetId = item.id;
    var selectedRow = _.find($scope.treeRows, function(x){
      return x.assetId == assetId;
    });
    if(selectedRow) {
      selectedRow.selected = false;
    }
    $scope.selectedAssets.splice(index, 1);
  };

  $scope.checkSelectedAsset = function(row) {
    var assetId = row.assetId;
    row.selected =_.findIndex($scope.selectedAssets, function(item){ return item.id == assetId}) > -1 ;
  };

  $scope.isNoData = function() {
    return $scope.treeRows.length === 0;
  };

  $scope.isShowInfiniteScroll = function() {
    return $scope.viewType === 'default';
  };

  $scope.onClose  = function() {
    $modalInstance.dismiss();
  };

  $scope.onSubmit = function() {
    if (_.isFunction(dataSet['preSubmitHook'])) {
      $scope.ajaxAction = 'submitting';

      dataSet['preSubmitHook']($scope.selectedAssets).then(function () { // On success

        $scope.ajaxAction = 'submitted';
        $modalInstance.close($scope.selectedAssets);

      }, function () { // Error
        $scope.ajaxAction = 'failed';
      });
    } else $modalInstance.close($scope.selectedAssets);
  };

  $modalInstance.opened.then(function(isOpened) {
    if(isOpened) {
      $timeout(function(){
        var $element = $('#job-asset-widget-panel');
        $element.bind('keydown', function(e){
          if(e.which === 13  ) {
            //console.log($element.find('input.input-searchtext').is(':focus'));
            $scope.searchAssets($scope.inputs.searchText);
          }
        });
      },300);
    }
  });
    $scope.$on('$destroy', function(){
      $('#job-asset-widget-panel').unbind('keydown');
    });

  function getRootRowsCount() {
    return _.filter($scope.treeRows, function(x){
      return x.level === 1;
    }).length;
  }

  function onSelect(item) {
    var that = _.isUndefined(item) ? this : item;
    if(that.selected) {
      $scope.selectedAssets.unshift({
        id: that.assetId,
        text: that.listData,
        assettypeid: that.assettypeid
      });
    }
    else {
      var index = _.findIndex($scope.selectedAssets, function(item){
        return item.id == that.assetId;
      });
      $scope.selectedAssets.splice(index, 1);
    }
  }

/*  function autoExpand(datas) {
    var t = [];
    function callall(items){
      _.forEach(items, function(item){
        t.push(item);
        if(item.children.length > 0) {
          item.expanded=true;
          callall(item.children);
        }
      })
    }
    callall(datas);
    return t;
  }*/

  function _prepareDummyRow(topLevelChildren) {
      return {
        isRoot: true,
        isDummy: true,
        uid: "" + Math.random(),
        visible: true,
        colSpan: 2,
        children: topLevelChildren
      };
    }

  $scope.$on('cstree:onchange', function (event, item) {
    onSelect(item);
  });

  function _onToggleCallback(index, isChild) {

    var row = this, nthIndex = index+1;
    if(!row.hasChild || row.loading===true) {
      return false;
    }
    if(!row.expanded) {
      row.loading = true;
      if(!_.has(row,'viewType')) {
        $('#loading-indicator').hide();
        $http.get(_resolveUrl({parentAssetId: row.assetId})).success(function(data,status){
          if(status !== 200) {
            return false;
          }
          var _datas = _prepareRecords(data, row);
          row.loading = false;
          row.expanded = true;
          if(isChild) {
            row.showChildren=true;
            row.children = _prepareRecords(data,row);
          }
          else {
            $scope.treeRows.splice(nthIndex,0, _prepareDummyRow( _prepareRecords(data, row) ));
          }
        });
      }
      else {
        if(row.isRoot) {
          $scope.treeRows[index+1].visible=true;
        }
        else {
          row.showChildren=true;
        }
        row.expanded=true;
        row.loading = false;
      }
    }
    else {
      //collapse
      if(row.isRoot) {
        if(_.has(row,'viewType') && row.viewType==='searchText') {
          $scope.treeRows[index+1].visible=false;
        }
        else {
          $scope.treeRows.splice(index+1, 1);
        }
      }
      else {
        if(_.has(row,'viewType') && row.viewType==='searchText') {
          row.showChildren=false;
        }
        else {
          row.children=[];
        }

      }
      row.expanded=false;
      row.loading = false;
    }
  }

    var expanding_property = _.find(columns, function(x){
      return _.has(x, 'expanding_property') && x['expanding_property'] === true;
    });

  function _prepareRecords(data, parentItem) {
    expanding_property = _.find(columns, function(x){
      return _.has(x, 'expanding_property') && x['expanding_property'] === true;
    });

    var items = data.assetResults,
      _tree_data=[],
      _cols, expanding_property,
      _isHaveParent = _.isUndefined(parentItem) ? false : _.isObject(parentItem) ? true : false;
    _.forEach(items, function(item, key){
      item.isDummy = false;
      item.isRoot = !_isHaveParent;
      item.isNodeView = _isHaveParent ? true : false;
      item.subAssetCount = parseInt(item.subAssetCount);
      item.hasChild = item.subAssetCount > 0;
      item.children = [];
      item.level = _isHaveParent ? parentItem.level+1 : 1;
      item.visible = true;
      item.uid = "" + Math.random();
      item.parent_uid = !_isHaveParent ? null : "" + parentItem.uid;
      item.loading = false;
      item.expanded = false;
      item.selected = _.findIndex($scope.selectedAssets, function(x){ return x.id == item.assetId}) > -1;;
      item.onSelect = onSelect;
      item.onExpandOrCollapse = _onToggleCallback;
      item.colSpan = !_isHaveParent ? null : $scope.colDefinitions.length;
      item.isLast = key === (items.length-1);
      item.isFirst = key === 0;
      item.vBars = _.range(1, item.level);
      item.parentLastRow = _.has(parentItem,'isLast') ? parentItem.isLast : false;
      item.default = item[expanding_property.field];
      if(_isHaveParent) {
        item[$scope.expandingProperty.field] = item.listData;
      }
      _tree_data.push(item);
    });
    if(_isHaveParent) {
      return _tree_data;
    }
    _cols = _.chain(columns)
      .reject(function(x){
        return _.has(x, 'expanding_property') && x['expanding_property'] === true;
      }).value();

    return {
      records: _tree_data,
      cols: _cols,
      expanding_property : expanding_property
    };
  }
  function _resolveUrl(additionalParams) {
    var addParam = !_.isObject(additionalParams) ? {} : additionalParams,
      url = prefix + '/get_asset_widget_details?',
      params = _.extend(angular.copy(dataSet.params), addParam);
    _.forEach(params, function(value, name){
      if(value != '') {
          url += name + "=" + value + "&";
      }
    });
    url = url.slice(0,-1);
    return url;
  }

  function list_to_tree(list) {
    var map = {}, node, roots = [], i;
    for (i = 0; i < list.length; i += 1) {
      map[list[i].assetId] = i; // initialize the map
      list[i].children = []; // initialize the children
      list[i].isRoot = false;
    }
    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.parentAssetId !== null) {
        // if you have dangling branches check that map[node.parentId] exists
        list[map[node.parentAssetId]].children.push(node);
      } else {
        roots.push(node);
      }
    }
    return  _createDummyRows(roots);
  }

  function _createDummyRows(rootDatas) {
    var cloneDatas = Object.assign([], rootDatas);
    var newRootDatas=[];
    _.forEach(cloneDatas, function(data, index){
      var children = [];
      if(data.children.length > 0) {
        children =  data.children;
        //data.children = [];
      }
      newRootDatas.push(data);
      if(children.length > 0) {
        newRootDatas.push(_prepareDummyRow( children ));
      }
    });
    return newRootDatas;
  }

    /**
     *
     * @param datas
     * @returns {Array}
     * api data transformed as tree structure for searchText type
     */
  function _transformAsTree(datas, isExpand) {
    var map = {}, assetResults=datas.assetResults;
    if(assetResults.length === 0) {
      return [];
    }
    var rootObj = _.map(list_to_tree( Object.values(assetResults) ), function(item){
      item.isRoot = true;
      return item;
    });
    //console.log("__", _.clone(rootObj), assetResults);
    return _prepareRecords4Tree(rootObj);
  }

  function _prepareRecords4Tree(items, parentItem) {
    var _isHaveParent = _.isUndefined(parentItem) ? false : _.isObject(parentItem) ? true : false,
    _tree_data=[];
    _.forEach(items, function(item, key){
      // item.isDummy = false;
      item.subAssetCount = parseInt(item.subAssetCount);
      item.hasChild = item.children.length > 0;
      item.showChildren=true;
      item.level = _isHaveParent ? parentItem.level+1 : 1;
      item.visible = true;
      item.uid = "" + Math.random();
      item.parent_uid = !_isHaveParent ? null : "" + parentItem.uid;
      item.loading = false;
      item.expanded = item.hasChild;
      item.selected = _.findIndex($scope.selectedAssets, function(x){ return x.id == item.assetId}) > -1;
      item.onSelect = onSelect;
      item.onExpandOrCollapse = _onToggleCallback;
      //item.colSpan = !_isHaveParent ? null : $scope.colDefinitions.length;
      item.colSpan = item.isDummy===true ? 2 : null;
      item.isNodeView = _isHaveParent ? true : false;
      item.isLast = key === (items.length-1);
      item.isFirst = key === 0;
      item.vBars = _.range(1, item.level);
      item.viewType='searchText';
      item.parentLastRow = _.has(parentItem,'isLast') ? parentItem.isLast : false;
      item.default = item[expanding_property.field];
      if(_isHaveParent) {
        item[$scope.expandingProperty.field] = item.listData;
      }
      if(item.children.length > 0) {
        item.children = _prepareRecords4Tree(item.children, item);
      }
      _tree_data.push(item);
    });
    return _tree_data;
  }

    function _enableTooltip() {
        $timeout(function(){
            var element = $('#job-asset-widget-panel');
            if(!element.length) {
                return;
            }
            element.tooltip({
                container: 'body',
                selector: '.asset-widget-text-decoration',
                title: function() {
                    return $(this).attr('tooltip-titles')
                }
            });
        },300);
    }

  /*function autoExpand(items) {
    var tmp=[], nthIndex=1;
    function _format() {
      _.forEach(items, function(item, index) {
        tmp.push(item)
        if(tmp[index].children.length > 0) {
          tmp[index].loading = false;
          tmp[index].expanded = true;
          _.forEach(tmp[index].children, function(child, key) {
            var _nidx = nthIndex + key;
          })
        }
      });
    }
  }*/
}]);
